import type { Routes } from '@angular/router';
import { ClaimsGuard } from '../../auth/guard/claims.guard';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

export const BIOLOGICAL_SAMPLING_ROUTES: Routes = [
  {
    path: 'biological-sampling',
    canActivate: [ClaimsGuard],
    data: {
      claims: [
        getClaimString(AppFeature.ResearchBiologicalSampling, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/biological-sampling.component').then(
        m => m.BiologicalSamplingComponent
      ),
  },
  {
    path: 'biological-sampling/:id',
    canActivate: [ClaimsGuard],
    data: {
      claims: [
        getClaimString(AppFeature.ResearchBiologicalSampling, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import(
        './components/detailed-biological-sampling/detailed-biological-sampling.component'
      ).then(m => m.DetailedBiologicalSamplingComponent),
  },
];
